@let isTermsAcceptedValid = notificationsForm.value.smsTermsAccepted || !isPopulatedString(notificationsForm.value.mobilePhone);
<mat-card class="max-w-[25rem]">
  <mat-card-content class="flex flex-col gap-y-3">
    <div class="text-headline-large">Notification Preferences</div>
    <div class="text-body-large">Select how you would like to receive notifications. Don’t worry, you’ll be able to
      change these options later!
    </div>
    <mx-input-form-field fieldName="notificationEmail" [formGroup]="notificationsForm"/>
    <mx-phone-form-field fieldName="mobilePhone" overrideLabel="Mobile Phone Number" [formGroup]="notificationsForm"/>
    <div>
      <div class="text-body-medium">I prefer to be contacted by:</div>
      <mx-radio-group-form-field fieldName="notifyMethod" [options]="NOTIFICATION_OPTIONS"
                                 [formGroup]="notificationsForm"/>
    </div>
    <px-sms-terms-checkbox fieldName="smsTermsAccepted" [formGroup]="notificationsForm"
                           [isTermsAcceptedValid]="isTermsAcceptedValid"/>
    <mx-filled-button label="Submit" [enabled]="notificationsForm.valid" (click)="onClickNext()"/>
  </mat-card-content>
</mat-card>
<div class="max-w-[50%] relative overflow-hidden ml-4 flex flex-row items-center md:w-[50%] lg:max-w-[29.5rem]">
  <img ngSrc="/assets/registration/set-notifications.png" fill priority alt=""
       class="relative hidden md:flex md:w-full md:h-auto lg:max-w-[29.5rem]"/>
</div>
